import { render, staticRenderFns } from "./EmployeeExtensionField.vue?vue&type=template&id=42cbe76f&"
import script from "./EmployeeExtensionField.vue?vue&type=script&lang=js&"
export * from "./EmployeeExtensionField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports